import type { HrefBuilder } from './urls.js';

/**
 * auth front へのブラウザ URL（`basepath: '/auth'` / vite `base: '/auth/'`）。
 * SPA 内ルート（`/logout` 等）ではなく、他アプリからも到達できる絶対パスとして `/auth` を付ける。
 * auth-lib-front の `route()` と同じ規約。
 */
export const AUTH_ROUTE_TEMPLATES = {
  accountProfile: '/auth/account/profile',
  logout: '/auth/logout',
  systemAdmin: '/auth/system-admin',
  organizationMembers: '/auth/organizations/{organizationId}/settings/members',
  projectSettings: '/auth/organizations/{organizationId}/settings/projects/{projectId}',
} as const;

export type AuthRouteTemplate = (typeof AUTH_ROUTE_TEMPLATES)[keyof typeof AUTH_ROUTE_TEMPLATES];

export function fillAuthRouteTemplate(template: string, params: { organizationId?: string; projectId?: string }): string {
  return template.replace('{organizationId}', params.organizationId ?? '').replace('{projectId}', params.projectId ?? '');
}

export function resolveAuthHref(path: string, builder: HrefBuilder): { href: string; crossDomain: boolean } {
  // auth 設定ページはパスパラメータで対象が確定するため、プロジェクトクエリ (?pid=) は付けない。
  return builder({ host: 'qant', path, skipProjectParam: true });
}
